import api from './axiosInstance';
export const getAll = (params) => api.get('/accessory-prices', { params });
export const getHistory = (params) => api.get('/accessory-prices/history', { params });
export const getById = (id) => api.get(`/accessory-prices/${id}`);
export const create = (data) => api.post('/accessory-prices', data);
export const update = (id, data) => api.put(`/accessory-prices/${id}`, data);
export const remove = (id) => api.delete(`/accessory-prices/${id}`);
export const batchRemove = (ids) => api.post('/accessory-prices/batch-delete', { ids });
export const updateHistoryBasis = (historyId, data) => api.patch(`/accessory-prices/history/${historyId}`, data);
